export const convertShortcodeDivider = (text: string): string => {
  const shortcode = '[ADD_DIVIDER]';
  const indexStart = text.indexOf(shortcode);
  if (indexStart !== -1) {
    return text.split(shortcode).join('<hr>');
  }
  return text;
};
